var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarRateNotFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4312_37818)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9297 3L24.308 13.3501C24.4762 13.7477 24.741 14.0916 25.0757 14.3473C25.4105 14.6031 25.8034 14.7616 26.215 14.8069L36.9297 15.9868L28.9209 23.5635C28.6133 23.8545 28.384 24.2256 28.2561 24.6394C28.1283 25.0532 28.1063 25.4951 28.1925 25.9206L30.4363 37L21.1082 31.3325C20.7499 31.1148 20.3435 31.0002 19.9297 31.0002C19.5159 31.0002 19.1094 31.1148 18.7511 31.3325L9.4231 37L11.6669 25.9206C11.7531 25.4951 11.7311 25.0532 11.6033 24.6394C11.4754 24.2256 11.2461 23.8545 10.9385 23.5635L2.92969 15.9868L13.6444 14.8069C14.0559 14.7616 14.4489 14.6031 14.7836 14.3473C15.1184 14.0916 15.3832 13.7477 15.5514 13.3501L19.9297 3Z",
    stroke: "white",
    strokeWidth: 2.21635
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4312_37818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRateNotFill);
export default __webpack_public_path__ + "static/media/StarRateNotFill.5b6187b5eacedb68aac0d868184c3d6e.svg";
export { ForwardRef as ReactComponent };